import { render, staticRenderFns } from "./ProjectDrawerDetail.vue?vue&type=template&id=dca801cc"
import script from "./ProjectDrawerDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDrawerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports